import { convertNumberToPercentage } from 'src/utils/toolbelt';

export default class Keyboard {
  constructor (editor) {
    this.editor = editor;
    this.svgCanvas = editor.canvas;
  }

  TOOL_BUTTONS = [
    {
      fn: 'clickLine',
      evt: 'click',
      key: ['L', true]
    },
    {
      fn: 'clickRect',
      evt: 'mouseup',
      key: ['R', true],
      parent: '#tools_rect',
      icon: 'rect'
    },
    {
      fn: 'escEvent',
      evt: 'click',
      key: ['esc', false, false],
      hidekey: true
    },
    {
      fn: 'deleteSelected',
      key: ['del/backspace', true]
    },
    {
      key: 'ctrl+B',
      fn: 'clickBold'
    },
    {
      key: 'ctrl+I',
      fn: 'clickItalic'
    },
    {
      key: 'ctrl+U',
      fn: 'clickUnderline'
    },
    {
      key: 'ctrl+S',
      fn: 'saveCurrentPage'
    },
    {
      key: ['up', true],
      fn: 'moveSelected',
      args: [0, -1]
    },
    {
      key: ['down', true],
      fn: 'moveSelected',
      args: [0, 1]
    },
    {
      key: ['left', true],
      fn: 'moveSelected',
      args: [-1, 0]
    },
    {
      key: ['right', true],
      fn: 'moveSelected',
      args: [1, 0]
    },
    {
      key: 'shift+up',
      fn: 'moveSelected',
      args: [0, -10]
    },
    {
      key: 'shift+down',
      fn: 'moveSelected',
      args: [0, 10]
    },
    {
      key: 'shift+left',
      fn: 'moveSelected',
      args: [-10, 0]
    },
    {
      key: 'shift+right',
      fn: 'moveSelected',
      args: [10, 0]
    },
    {
      key: 'tab',
      fn: 'changeAlign'
    },
    {
      key: 'ctrl+Z',
      fn: 'clickUndo'
    },
    {
      key: 'ctrl+shift+Z',
      fn: 'clickRedo'
    },
    {
      key: 'ctrl+P',
      fn: 'printDesign'
    },
    {
      key: 'ctrl+G',
      fn: 'clickGroup'
    },
    {
      key: 'ctrl+shift+G',
      fn: 'clickUnGroup'
    },
    {
      key: 'ctrl+L',
      fn: 'lockSelected'
    },
    {
      key: 'ctrl+D',
      fn: 'duplicateSelected'
    },
    {
      key: 'ctrl+A',
      fn: 'selectAll'
    },
    {
      key: 'ctrl+shift+D',
      fn: 'openDownload'
    },
    {
      key: 'ctrl+P',
      fn: 'openPrint'
    },
    {
      key: 'I',
      fn: 'openImages'
    },
    {
      key: 'T',
      fn: 'openText'
    },
    {
      key: 'ctrl+R',
      fn: 'showRulers'
    },
    {
      key: 'alt+A',
      fn: 'alignLeft'
    },
    {
      key: 'alt+H',
      fn: 'alignHorizontalMiddle'
    },
    {
      key: 'alt+D',
      fn: 'alignRight'
    },
    {
      key: 'alt+V',
      fn: 'alignVerticalMiddle'
    },
    {
      key: 'alt+W',
      fn: 'alignTop'
    },
    {
      key: 'alt+S',
      fn: 'alignBottom'
    },
    {
      key: 'alt+ctrl+shift+T',
      fn: 'tidyTwoDimension'
    },
    {
      key: 'alt+shift+V',
      fn: 'distributeVertical'
    },
    {
      key: 'alt+shift+H',
      fn: 'distributeHorizontal'
    }
  ];

  clickBold () {
    const selectedElements = _.toArray(this.svgCanvas.getSelectedElems());
    const canChangeDecoration = _.all(selectedElements, function (el) {
      return INKIVE.RestrictionsFacade.isActionAllowed('text_decoration', el);
    });

    canChangeDecoration && $('.btn-onmenu[data-action="on_set-bold"]').click();
  }

  clickItalic () {
    const selectedElements = _.toArray(this.svgCanvas.getSelectedElems());
    const canChangeDecoration = _.all(selectedElements, function (el) {
      return INKIVE.RestrictionsFacade.isActionAllowed('text_decoration', el);
    });

    canChangeDecoration && $('.btn-onmenu[data-action="on_set-italic"]').click();
  }

  clickUnderline () {
    const selectedElements = _.toArray(this.svgCanvas.getSelectedElems());
    const canChangeDecoration = _.all(selectedElements, function (el) {
      return INKIVE.RestrictionsFacade.isActionAllowed('text_decoration', el);
    });

    canChangeDecoration && $('.btn-onmenu[data-action="on_set-underline"]').click();
  }

  clickUndo () {
    $('#layoutScreen').length || INKIVE.History.undo();
  }

  clickRedo () {
    $('#layoutScreen').length || INKIVE.History.redo();
  }

  escEvent () {
    const $layoutCloseBtn = $('[data-action=on_layoutClose]');
    const $popupContainers = $('.ui-dropdown-content');
    const $popupButtons = $('.ui-dropdown-button');

    if ($('.ui-dropdown.active').length) {
      $(document).trigger('mouseup');
    } else if ($layoutCloseBtn.length) {
      $layoutCloseBtn.click();
    } else if ($popupButtons.is('.active')) {
      $popupContainers.fadeOut('fast');
      $popupButtons.removeClass('active');
    } else if (this.svgCanvas.getSelectedElems().length) {
      this.svgCanvas.clearSelection();
    } else {
      this.svgCanvas.leaveContext();
    }

    if (this.svgCanvas.getMode() === 'table-edit') {
      INKIVE.Table.endTableEditingMode();
    }
  }

  deleteSelected () {
    const selectedElements = _.toArray(this.svgCanvas.getSelectedElems());
    const tableElements = selectedElements.filter(element => element.classList.contains('table'));

    if (selectedElements !== null) {
      const canRemove = _.all(selectedElements, function (el) {
        return INKIVE.RestrictionsFacade.canChange(el, 'deletion');
      });

      if (this.svgCanvas.getMode() === 'table-edit') {
        for (const tableElement of tableElements) {
          const cells = tableElement?.querySelectorAll('.table-cell');
          const selectedCells = tableElement?.querySelectorAll('.table-cell-selected');

          if (selectedCells.length !== cells.length) {
            INKIVE.Table.clearTextInCells(selectedCells);

            return;
          }
        }
      }

      if (canRemove) {
        if (selectedElements.length > 5) {
          INKIVE.DesignFacade.handle('delete_multiple');
        } else {
          _.each(selectedElements, function (el) {
            INKIVE.DesignFacade.handle(el.getAttribute('id'), 'delete');
          });
        }
      }
    }
  }

  moveSelected (dx, dy) {
    if ($('#layoutScreen').length) {
      return;
    }

    const rf = INKIVE.RestrictionsFacade;
    const selectedElements = _.toArray(this.svgCanvas.getSelectedElems());

    if (Array.isArray(selectedElements) && selectedElements.length) {
      const elem = selectedElements[0];

      if (INKIVE.DesignFacade.get(elem.id).type === 'background' && !elem.classList.contains('layoutClipperImage')) {
        return;
      }

      const canMove = _.all(selectedElements, function (el) {
        return rf.canChange(el, 'position') && !$(el).is('.locked');
      });

      if (canMove) {
        _.all(selectedElements, function (el) {
          let restrictedMovement = rf.applyRestriction(el, 'margin', {
            x: dx,
            y: dy
          });

          restrictedMovement = rf.applyRestriction(el, 'movement', restrictedMovement);

          dx = restrictedMovement.x;
          dy = restrictedMovement.y;
        });

        this.svgCanvas.moveSelectedElements(dx, dy);

        INKIVE.DesignFacade.trigger('move');

        this.svgCanvas.runExtensions('recalculateOutsideCanvasSelectionBox', {});
        this.svgCanvas.runExtensions('clear', {});
      }
    }
  }

  changeAlign () {
    const $text = $(this.svgCanvas.getSelectedElems()).find('text');

    if ($text.length) {
      const $popupmenu = $('.menu.element-popupmenu');
      const positionButtonSelectors = [
        'a[data-action="on_set-align-left"]',
        'a[data-action="on_set-align-center"]',
        'a[data-action="on_set-align-right"]'
      ];

      _.any(positionButtonSelectors, function (selector, index) {
        if ($popupmenu.find(selector).hasClass('applied')) {
          const nextIndex = index > positionButtonSelectors.length - 2
            ? 0
            : index + 1;

          $popupmenu.find(positionButtonSelectors[nextIndex])
            .trigger('click');
          document.querySelectorAll('.ui-dropdown-items.horizontal').forEach(el => {
            el.style.display = 'none';
          });
          return true;
        }
      });
    }
  }

  clickLine () {
    this.svgCanvas.setMode('line');
  }

  clickRect () {
    this.svgCanvas.setMode('rect');
  }

  saveCurrentPage () {
    INKIVE.EditorFacade.trigger('page.save_from_keyboard', {});
  }

  printDesign () {
    $('[data-action=print]').click();
  }

  clickGroup () {
    INKIVE.DesignFacade.create('group');
  }

  clickUnGroup () {
    INKIVE.DesignFacade.handle('ungroup');
    this.svgCanvas.clearSelection();
  }

  moveForwardSelected () {
    const selectedElements = this.svgCanvas.getSelectedElems();

    if (Array.isArray(selectedElements) && selectedElements.length) {
      selectedElements.forEach(el => {
        INKIVE.DesignFacade.handle(el.id, 'send_forward');
      });
    }
  }

  moveBackwardSelected () {
    const selectedElements = this.svgCanvas.getSelectedElems();

    if (Array.isArray(selectedElements) && selectedElements.length) {
      selectedElements.forEach(el => {
        INKIVE.DesignFacade.handle(el.id, 'send_backward');
      });
    }
  }

  moveToTopSelected () {
    const selectedElements = this.svgCanvas.getSelectedElems();

    if (Array.isArray(selectedElements) && selectedElements.length) {
      INKIVE.DesignFacade.handle(selectedElements[0].id, 'send_top');
    }
  }

  moveToBottomSelected () {
    const selectedElements = this.svgCanvas.getSelectedElems();

    if (Array.isArray(selectedElements) && selectedElements.length) {
      INKIVE.DesignFacade.handle(selectedElements[0].id, 'send_bottom');
    }
  }

  lockSelected () {
    const selectedElements = this.svgCanvas.getSelectedElems();
    const lockedArray = [];

    if (selectedElements !== null) {
      selectedElements.forEach(function (elem) {
        lockedArray.push(INKIVE.DesignFacade.get(elem.id).locked);
      });
      INKIVE.DesignFacade.set({ locked: !lockedArray.includes(true) });
      INKIVE.Menus.elementPopupMenu.refresh();
    }
  }

  duplicateSelected () {
    const selectedElements = this.svgCanvas.getSelectedElems();

    if (Array.isArray(selectedElements) && selectedElements.length) {
      INKIVE.DesignFacade.handle(selectedElements[0].id, 'duplicate');
      INKIVE.Tool.blinkScreen(selectedElements[0]);
    }
  }

  selectAll () {
    this.svgCanvas.selectAllInCurrentLayer();
  }

  openDownload () {
    document.querySelector('.ui-dropdown-button[data-id="download"]').click();
  }

  openPrint () {
    document.querySelector('.ui-dropdown-button[data-id="order-print"]').click();
  }

  openImages () {
    document.querySelector('.btn-tag[href="#tabImages"]').click();
  }

  openText () {
    document.querySelector('.btn-tag[href="#tabText"]').click();
  }

  showRulers () {
    const isRulersAndGuidesShown = this.svgCanvas.runExtensions(
      'isRulersAndGuidesShown',
      {}
    );
    const action = isRulersAndGuidesShown
      ? 'hideRulersAndGuides'
      : 'showRulersAndGuides';
    this.svgCanvas.runExtensions(action, {});
  }

  alignTop () {
    const selectedElements = this.svgCanvas.getSelectedElems();
    const relativeTo = selectedElements && selectedElements?.length > 1 ? 'selection' : 'page';
    const offset = convertNumberToPercentage(document.querySelector('input#margin')?.value ?? 0);

    INKIVE.EditorFacade.handle('align', {
      relative_to: relativeTo,
      position: 'top',
      offset
    });
  }

  alignRight () {
    const selectedElements = this.svgCanvas.getSelectedElems();
    const relativeTo = selectedElements && selectedElements?.length > 1 ? 'selection' : 'page';
    const offset = convertNumberToPercentage(document.querySelector('input#margin')?.value ?? 0);

    INKIVE.EditorFacade.handle('align', {
      relative_to: relativeTo,
      position: 'right',
      offset
    });
  }

  alignBottom () {
    const selectedElements = this.svgCanvas.getSelectedElems();
    const relativeTo = selectedElements && selectedElements?.length > 1 ? 'selection' : 'page';
    const offset = convertNumberToPercentage(document.querySelector('input#margin')?.value ?? 0);

    INKIVE.EditorFacade.handle('align', {
      relative_to: relativeTo,
      position: 'bottom',
      offset
    });
  }

  alignLeft () {
    const selectedElements = this.svgCanvas.getSelectedElems();
    const relativeTo = selectedElements && selectedElements?.length > 1 ? 'selection' : 'page';
    const offset = convertNumberToPercentage(document.querySelector('input#margin')?.value ?? 0);

    INKIVE.EditorFacade.handle('align', {
      relative_to: relativeTo,
      position: 'left',
      offset
    });
  }

  alignVerticalMiddle () {
    const selectedElements = this.svgCanvas.getSelectedElems();
    const relativeTo = selectedElements && selectedElements?.length > 1 ? 'selection' : 'page';

    INKIVE.EditorFacade.handle('align', {
      relative_to: relativeTo,
      position: 'vertical_middle'
    });
  }

  alignHorizontalMiddle () {
    const selectedElements = this.svgCanvas.getSelectedElems();
    const relativeTo = selectedElements && selectedElements?.length > 1 ? 'selection' : 'page';

    INKIVE.EditorFacade.handle('align', {
      relative_to: relativeTo,
      position: 'horizontal_middle'
    });
  }

  tidyTwoDimension () {
    const selectedElements = this.svgCanvas.getSelectedElems();
    if (selectedElements.length > 1) {
      INKIVE.EditorFacade.handle('distribute', 'tidy2d', {
        selectedElements
      });
    }
  }

  distributeVertical () {
    const selectedElements = this.svgCanvas.getSelectedElems();
    if (selectedElements.length > 1) {
      INKIVE.EditorFacade.handle('distribute', 'vertical', {
        selectedElements
      });
    }
  }

  distributeHorizontal () {
    const selectedElements = this.svgCanvas.getSelectedElems();
    if (selectedElements.length > 1) {
      INKIVE.EditorFacade.handle('distribute', 'horizontal', {
        selectedElements
      });
    }
  }

  init () {
    // Associate all button actions as well as non-button keyboard shortcuts
    this.setAll();
  }

  setAll () {
    const that = this;
    const isMacLike = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
    this.TOOL_BUTTONS.forEach((opts, i) => {
      if (opts.key) {
        let keyval;
        const fn = opts.fn;
        const args = opts.args;
        let pd = false;

        if ($.isArray(opts.key)) {
          keyval = opts.key[0];
          if (opts.key.length > 1) pd = opts.key[1];
        } else {
          keyval = opts.key;
        }
        keyval += '';

        if (keyval.indexOf('ctrl+') > -1 && isMacLike) {
          keyval = keyval.replace('ctrl', 'meta');
        }

        keyval.split('/').forEach((key) => {
          $(document).bind('keydown', key, (e) => {
            const invalidTarget =
            e.target instanceof HTMLInputElement ||
            e.target.type === 'input' ||
            e.target.type === 'textarea' ||
            e.target.classList.contains('avoid-shortcuts');
            if (!invalidTarget && !e.target.shadowRoot) {
              INKIVE.Helpers.executeFunctionByName(fn, this, args);
              if (pd) {
                e.preventDefault();
              }
              // Prevent default on ALL keys?
              return false;
            }
          });
        });
      }
    });

    // Misc additional actions

    // Make "return" keypress trigger the change event
    $('.attr_changer, #image_url').bind('keydown', 'return',
      function (e) {
        if ($(e.target).is('input, textarea, .avoid-shortcuts')) {
          return e;
        }

        $(this).change();
        e.preventDefault();
      }
    );

    $(window).bind('keydown', 'tab', function (e) {
      if ($(e.target).is('input, textarea, .avoid-shortcuts')) {
        return e;
      }

      e.preventDefault();
      that.svgCanvas.cycleElement(1);
    }).bind('keydown', 'shift+tab', function (e) {
      if ($(e.target).is('input, textarea, .avoid-shortcuts')) {
        return e;
      }

      e.preventDefault();
      that.svgCanvas.cycleElement(0);
    });

    const plusKeys = [61, 107, 187];
    const minusKeys = [109, 173, 189];
    const zero = [48];
    const closeBracket = 221;
    const openBracket = 219;

    $(document).keydown(function (event) {
      if ($(event.target).is('input, textarea, .avoid-shortcuts')) {
        return event;
      }
      const isCtrlKey = isMacLike ? event.metaKey : event.ctrlKey;
      if (isCtrlKey && _.include(_.union(plusKeys, minusKeys, zero), event.which)) {
        let action = _.includes(plusKeys, event.which) ? 'in' : 'out';
        if (event.which === zero[0]) {
          action = 'fit';
          document.querySelector('.zoom-wrapper .custom').textContent = 'Fit';
        }

        INKIVE.EditorFacade.handle('zoom', action);
        event.preventDefault();
      } else if (isCtrlKey && event.altKey && event.which === closeBracket) {
        INKIVE.Helpers.executeFunctionByName('moveToTopSelected', that);
        event.preventDefault();
      } else if (isCtrlKey && event.which === closeBracket) {
        INKIVE.Helpers.executeFunctionByName('moveForwardSelected', that);
        event.preventDefault();
      } else if (isCtrlKey && event.altKey && event.which === openBracket) {
        INKIVE.Helpers.executeFunctionByName('moveToBottomSelected', that);
        event.preventDefault();
      } else if (isCtrlKey && event.which === openBracket) {
        INKIVE.Helpers.executeFunctionByName('moveBackwardSelected', that);
        event.preventDefault();
      }
    });

    let params, ticking;
    // Zoom editor
    const container = document.querySelector('#editor');
    const target = container.children[0];
    target.addEventListener('wheel', scrolled);

    function scrolled (e) {
      const isCtrl = !isMacLike && e.ctrlKey;
      const isCmd = isMacLike && e.metaKey;
      if (isCtrl || isCmd) {
        e.preventDefault();
        document.querySelector('#selectorParentGroup').classList.remove('hidden');
        document.querySelectorAll('.distanceLineGroup').forEach((distanceLine) => distanceLine.remove());
        that.svgCanvas.clearSelection();
        that.svgCanvas.setMode('zooming');

        const delta = e.wheelDelta;
        params = { e, delta };
        if (!ticking) {
          ticking = window.requestAnimationFrame(function () {
            INKIVE.EditorFacade.handle('zoom', 'scrollToZoom', params);
            ticking = null;
          });
        }
      }
    }

    const ele = document.querySelector('#workarea');
    let pos = { top: 0, left: 0, x: 0, y: 0 };
    let isMouseDown = false; // check if mouse is down or not
    let needForRAF = true; // to prevent redundant rAF calls
    let dx, dy;

    const mouseDownHandler = function (e) {
      e.preventDefault();
      isMouseDown = true;
      pos = {
      // The current scroll
        left: ele.scrollLeft,
        top: ele.scrollTop,
        // Get the current mouse position
        x: e.clientX,
        y: e.clientY
      };
      document.addEventListener('mousemove', mouseMoveHandler);
      document.addEventListener('mouseup', mouseUpHandler);
    };

    function mouseMoveHandler (e) {
    // How far the mouse has been moved
      dx = e.clientX - pos.x;
      dy = e.clientY - pos.y;

      if (needForRAF && isMouseDown) {
        needForRAF = false; // no need to call rAF up until next frame
        requestAnimationFrame(update); // request 60fps animation
      }
    }

    function update () {
      needForRAF = true; // rAF now consumes the movement instruction so a new one can come
      ele.scrollTop = pos.top - dy;
      ele.scrollLeft = pos.left - dx;
    }

    function mouseUpHandler () {
      isMouseDown = false; // reset mouse is down boolean
      document.removeEventListener('mousemove', mouseMoveHandler);
      document.removeEventListener('mouseup', mouseUpHandler);
    }

    function keyDownHandler (e) {
      const invalidTarget =
      e.target.type === 'text' ||
      e.target.type === 'input' ||
      e.target.type === 'textarea' ||
      e.target.classList.contains('avoid-shortcuts');
      if (e.code === 'Space' && !invalidTarget) {
        e.preventDefault();
        document.addEventListener('mousedown', mouseDownHandler);
      }
      document.addEventListener('keyup', keyUpHandler);
    }

    function keyUpHandler () {
      document.removeEventListener('mousedown', mouseDownHandler);
    }

    document.addEventListener('keydown', keyDownHandler);
  }
}
